import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  DEFAULT_PURCHASE_TRANSACTION_FILTERS,
  mergePurchaseTransactionFilters,
  parsePurchaseTransactionFilters,
  type PurchaseTransactionFilters,
} from './purchaseTransactionFilterParams';

export type {
  PurchaseTransactionFilters,
  StatusFilter,
  TypeFilter,
  PaymentMethodFilter,
  SortKey,
  SortDir,
} from './purchaseTransactionFilterParams';

export const usePurchaseTransactionFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useMemo(
    () => parsePurchaseTransactionFilters(searchParams),
    [searchParams]
  );

  const listSearch = searchParams.toString();

  const updateFilters = useCallback(
    (patch: Partial<PurchaseTransactionFilters>, options?: { replace?: boolean }) => {
      setSearchParams(mergePurchaseTransactionFilters(searchParams, patch), {
        replace: options?.replace ?? true,
      });
    },
    [searchParams, setSearchParams]
  );

  const clearFilters = useCallback(() => {
    setSearchParams({}, { replace: true });
  }, [setSearchParams]);

  const hasActiveFilters = useMemo(() => {
    return (
      filters.searchQuery !== DEFAULT_PURCHASE_TRANSACTION_FILTERS.searchQuery ||
      filters.vendorFilter !== DEFAULT_PURCHASE_TRANSACTION_FILTERS.vendorFilter ||
      filters.statusFilter !== DEFAULT_PURCHASE_TRANSACTION_FILTERS.statusFilter ||
      filters.typeFilter !== DEFAULT_PURCHASE_TRANSACTION_FILTERS.typeFilter ||
      filters.paymentMethodFilter !== DEFAULT_PURCHASE_TRANSACTION_FILTERS.paymentMethodFilter ||
      filters.datePreset !== DEFAULT_PURCHASE_TRANSACTION_FILTERS.datePreset
    );
  }, [filters]);

  return {
    filters,
    listSearch,
    updateFilters,
    clearFilters,
    hasActiveFilters,
  };
};
